export enum ServiceTypeMobility {
  UNDEFINED_SERVICE_TYPE = 'UNDEFINED_SERVICE_TYPE',
  HOME_DELIVERY = 'HOME_DELIVERY',
  HOME_INSTALLATION = 'HOME_INSTALLATION',
}

export const ServiceTypeMobilityLabelKey: Record<
  ServiceTypeMobility,
  string | null
> = {
  [ServiceTypeMobility.UNDEFINED_SERVICE_TYPE]: null,
  [ServiceTypeMobility.HOME_DELIVERY]:
    'service_manager.gantt.mobility_service_type.home_delivery',
  [ServiceTypeMobility.HOME_INSTALLATION]:
    'service_manager.gantt.mobility_service_type.home_installation',
};
